import type { ConsentForm, Resident } from '@lmc/ts-common'

import { LabelTextBox } from '@lmc/ui-kit'
import type * as React from 'react'
import { isBrowser, isTablet } from 'react-device-detect'

type ConsentFormTextBoxProps = {
  consentForm: ConsentForm
  localisation: {
    title: string
    subTitle: string
    readOnly: string
  }
  resident: Resident
  styles?: React.CSSProperties
}

export const ConsentFormTextBox = ({
  consentForm,
  localisation,
  resident,
  styles: wrapperStyles
}: ConsentFormTextBoxProps): React.ReactElement => {
  const isMobile = !isBrowser && !isTablet

  return (
    <LabelTextBox
      isMobile={isMobile}
      style={{ ...styles.labelTextBox, ...wrapperStyles }}
      localisation={localisation}
      content={consentForm?.body?.replace(
        /{name}/g,
        resident?.preferredName || resident?.name?.first
      )}
      state="read-only"
    />
  )
}

const styles = {
  labelTextBox: { marginTop: 50 }
}

export default ConsentFormTextBox
